export const GET_TODAY_TASKS = 'GET_TODAY_TASKS';
export const GET_ALL_MEETING = 'GET_ALL_MEETING';
export const ACTIVITY_TRACK_SUBMIT = 'ACTIVITY_TRACK_SUBMIT';
export const ADD_MEETING = 'ADD_MEETING';
export const RESCHEDULE_APPOINTMENT = 'RESCHEDULE_APPOINTMENT';
export const CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT';
export const ADD_NEW_ACTIVITY_PLAN = 'ADD_NEW_ACTIVITY_PLAN';
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';
export const GET_ACTIVITY_BY_ID = 'GET_ACTIVITY_BY_ID';
export const GET_FUNCTIONAL_DESIGNATION = 'GET_FUNCTIONAL_DESIGNATION';
export const UPDATE_ACTIVITY_BY_ID = 'UPDATE_ACTIVITY_BY_ID';
export const PLAN_TYPE ='PLAN_TYPE';
export const CUSTOMER_DETAILS = 'CUSTOMER_DETAILS';
export const GET_OPEN_PROSPECTIVE = 'GET_OPEN_PROSPECTIVE'